/* eslint-disable @stylistic/max-len */
import React from 'react';
import propTypes from './propTypes';

const Rhubarb = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="13"
    height="20"
    fill="none"
    viewBox="0 0 13 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.744 19.176C5.0856 19.176 4.2456 17.8752 4.2456 15.312C4.2456 14.436 4.3416 13.4184 4.5816 11.8008L4.584 11.7816L4.5816 11.7624C4.3248 10.2912 3.9024 9.1392 3.2112 8.0328C2.508 6.9048 1.5144 5.7984 0 4.4568L3.048 1.2264L4.3656 2.5176V0H8.4984V2.4384L8.6952 2.2776C8.7936 2.1984 8.8776 2.1264 8.9544 2.064C9.3768 1.716 9.5184 1.5984 10.0176 1.2432L12.7248 4.4016C11.3976 5.4984 10.512 6.468 9.9432 7.4448C9.3528 8.4576 9.0768 9.516 9.0768 10.776C9.0768 11.8296 9.144 12.8472 9.204 13.7472C9.252 14.4576 9.2928 15.072 9.2928 15.576C9.2928 16.7736 9.0576 17.6952 8.5968 18.3096C8.1624 18.8832 7.5384 19.176 6.744 19.176ZM6.048 11.8752C5.8272 13.5 5.736 14.496 5.736 15.312C5.736 16.3536 5.8464 17.736 6.792 17.736C7.5 17.736 7.8 17.0112 7.8 15.312C7.8 14.7456 7.7664 14.0064 7.7328 13.2216C7.6944 12.3744 7.656 11.4984 7.656 10.776C7.656 9.456 7.9128 8.2944 8.4384 7.2288C8.8992 6.2976 9.5856 5.3928 10.5984 4.38L10.6728 4.3056L9.8088 3.2112L9.7152 3.2928C7.2072 5.436 5.904 8.4816 6.048 11.8752ZM2.0616 4.3488L2.1432 4.4304C3.2784 5.5632 4.2744 6.8808 4.812 7.9512L4.944 8.2152L5.0328 7.932C5.124 7.644 5.2032 7.428 5.3136 7.128C5.376 6.9576 5.448 6.7656 5.5344 6.5208L5.5536 6.4656L5.5248 6.4176C4.716 5.0952 4.0344 4.2984 3.1296 3.372L3.0408 3.2808L2.0616 4.3488ZM5.7096 4.02L6.36 4.9632L7.104 3.876L7.1304 1.3416H5.7624L5.7096 4.02Z" fill="currentColor" />
  </svg>
);

Rhubarb.propTypes = propTypes;

export default Rhubarb;
